const createHashHistory=require("history").createHashHistory
export default createHashHistory();